"use strict";
/**
 * @desc 로그인 후 보던 페이지 또는 이동할 path string 리턴
 */
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(path) {
    const { pathname, search } = window.location;
    const nextPath = path || `${pathname}${search}`;
    const canUserReturn = !pathname.includes('sign-up');
    return canUserReturn ? `/login/?next_page=${nextPath}` : '/login/';
}
exports.default = default_1;
